import React from "react";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { OrderProvider } from "@/context/OrderContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import MenuHighlights from "@/components/site/MenuHighlights";
import Story from "@/components/site/Story";
import FullMenu from "@/components/site/FullMenu";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Location from "@/components/site/Location";
import Footer from "@/components/site/Footer";
import OrderModal from "@/components/site/OrderModal";
import HalalPopup from "@/components/site/HalalPopup";
import OrderPage from "@/components/site/OrderPage";
import CheckoutDrawer from "@/components/site/CheckoutDrawer";
import AdminOrders from "@/components/site/AdminOrders";

const Home = () => (
  <div className="relative min-h-screen bg-ink text-cream selection:bg-gold">
    <HalalPopup />
    <Header />
    <main>
      <Hero />
      <BrandMarquee />
      <MenuHighlights />
      <Story />
      <FullMenu />
      <Gallery />
      <Testimonials />
      <Location />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <OrderProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/order" element={<OrderPage />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
            </Routes>
            <OrderModal />
            <CheckoutDrawer />
          </BrowserRouter>
        </CartProvider>
      </OrderProvider>
    </ReactLenis>
  );
}

export default App;
